import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  Snackbar,
  Container,
  CardHeader,
  CircularProgress,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { getPoBaseProductAction } from './Action';
import { useLocation, useNavigate } from 'react-router-dom';
import { createOrderBookingAction } from '../../screen/auth/action/util_actions';
import { bookStatus } from '../../utils/settings';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function POBooking() {
  const [loading, setLoading] = useState(false);
  const [baseProdDetails, setBaseProdDetails] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [userInput, setUserInput] = useState({
    booking_qty: null,
    po_id: '',
    po_id_copy: '',
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isEditingPoId, setIsEditingPoId] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  const getPoBaseProd = async () => {
    const { data, error, message } = await getPoBaseProductAction({
      manufacturer_id: Number(state?.seller_info?.id),
    });

    if (!error) {
      setBaseProdDetails(data);
    } else {
      //Throw error
    }
  };
  useEffect(() => {
    getPoBaseProd();
  }, [state]);

  const handleButtonClick = async () => {
    setLoading(true);
    const payload = {
      user_po_id: userInput.po_id,
      seller_id: state.seller_info.id,
      product_list: [
        {
          product_id: baseProdDetails?.product_info?.id,
          quantity: {
            quantity_in_metric_ton: Number(userInput.booking_qty),
          },
        },
      ],
      status: bookStatus['DISPATCH_PLAN_PENDING'],
      meta_data: {},
    };

    const { data, error, message } = await createOrderBookingAction(payload);

    if (!error) {
      //Show success
      setLoading(false);
      setShowSuccess(true);
      toast.success(message);
      navigate('/order-booking/po-list');
    } else {
      setLoading(false);
      return toast.error(message);
    }
  };

  return (
    <Container
      maxWidth='true'
      sx={{
        pl: '2rem',
        pt: '2rem',
        height: window.innerHeight,
        overflowY: 'auto',
        backgroundColor: 'rgba(245,245,245,.6)',
      }}
    >
      <Typography
        variant='h5'
        style={{ marginBottom: '2rem', fontWeight: 'bold' }}
      >
        Po/Order Booking
      </Typography>
      <Box
        sx={{
          bgcolor: '#ffffff',
          borderRadius: '10px',
          padding: 10,
        }}
      >
        <Stack
          direction={'row'}
          spacing={10}
          sx={{
            // backgroundColor:'red'
            width: '100%',
          }}
        >
          <Card
            sx={{
              width: '30rem',
              height: '20rem',
              borderRadius: 5,
            }}
          >
            <img
              style={{
                width: '30rem',
                height: '20rem',
                // borderRadius: 5,
              }}
              src={
                baseProdDetails?.product_info?.images?.length > 0
                  ? baseProdDetails?.product_info?.images[0]
                  : baseProdDetails?.product_info?.logo
              }
              //   alt={item.sub_industry_name}
            />
          </Card>
          <Stack
            sx={{
              width: '100%',
            }}
            spacing={2}
          >
            <Box>
              <Typography variant='h5'>{state?.seller_info?.name}</Typography>

              <Typography variant={'subtitle1'}>
                {baseProdDetails?.product_info?.name}
              </Typography>
            </Box>
            <Box width={'80%'}>
              <Grid container>
                <Grid
                  item
                  xs={6}
                >
                  <Typography
                    variant='subtitle1'
                    fontFamily={'sans-serif'}
                    fontWeight={'600'}
                  >
                    Today’s Price
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                >
                  <Stack
                    direction={'row'}
                    spacing={1}
                    alignItems={'center'}
                  >
                    <Typography
                      fontFamily={'sans-serif'}
                      fontWeight={'600'}
                    >
                      ₹{' '}
                      {
                        baseProdDetails?.price_info
                          ?.price_per_unit_gst_inclusive
                      }
                    </Typography>
                    <Typography
                      variant='subtitle2'
                      fontWeight={'600'}
                      color={'grey'}
                    >
                      Ex Factory Price
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
              <Grid container>
                <Grid
                  item
                  xs={6}
                >
                  <Typography
                    variant='subtitle1'
                    fontFamily={'sans-serif'}
                    fontWeight={'600'}
                  >
                    Length{' '}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                >
                  <Typography
                    fontFamily={'sans-serif'}
                    fontWeight={'600'}
                  >
                    {baseProdDetails?.product_info?.length}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Stack>
        </Stack>
      </Box>
      <Card sx={{ mt: '2rem', mb: '2rem' }}>
        <CardHeader
          title='Booking Details'
          sx={{ backgroundColor: '#f5f5f5' }}
          titleTypographyProps={{ fontSize: 20 }}
        />
        <CardContent>
          <Stack
            direction={'row'}
            sx={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              input: { cursor: 'pointer' },
              width: '60%',
            }}
          >
            <Typography
              variant='subtitle1'
              style={{ marginLeft: '2rem' }}
              fontWeight={'600'}
              fontSize={18}
            >
              Enter Quantity
            </Typography>
            <TextField
              label='Enter Quantity'
              placeholder='Enter Quantity'
              id='booking_qty'
              variant='outlined'
              style={{ width: '60%' }}
              inputProps={{ maxLength: 3 }}
              value={userInput?.booking_qty}
              onChange={(e) => {
                if (/^\d*$/.test(e.target.value)) {
                  setUserInput({ ...userInput, booking_qty: e.target.value });
                }
              }}
            />
          </Stack>
          <Stack
            direction={'row'}
            sx={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: '2rem',
              alignItems: 'baseline',
              input: { cursor: 'pointer' },
              width: '60%',
            }}
            spacing={10}
          >
            <Typography
              variant='subtitle1'
              style={{ marginLeft: '2rem' }}
              fontWeight={'600'}
              fontSize={18}
            >
              Enter User PO ID
            </Typography>
            <TextField
              label='Enter User PO ID'
              id='userPOId'
              placeholder='Placeholder'
              variant='outlined'
              style={{ width: '60%' }}
              onChange={(e) => {
                setUserInput({
                  ...userInput,
                  po_id: e.target.value,
                  po_id_copy: e.target.value,
                });
              }}
            />
          </Stack>
        </CardContent>
      </Card>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mb: '2rem',
        }}
      >
        <Button
          variant='contained'
          style={{
            backgroundColor: '#F59C1E',
            paddingLeft: '5rem',
            paddingRight: '5rem',
            borderRadius: '0.5rem',
            marginRight: '2rem',
            fontWeight: 'bold',
          }}
          onClick={() => handleButtonClick()}
          disabled={loading}
          startIcon={
            loading && (
              <CircularProgress
                sx={{ color: 'white' }}
                size={20}
              />
            )
          }
        >
          {loading ? 'Loading...' : ' Book Purchase Order'}
        </Button>
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Order Booked successfully'}
        // key={vertical + horizontal}
      />
    </Container>
  );
}

export default POBooking;
